import type { Href } from 'expo-router'
import type { ReactNode, RefObject } from 'react'
import type { View, ViewProps } from 'react-native'

import { useDimensions } from '@/src/general/hooks/useDimensions'
import type { TMainColor } from '@/src/styles/colors'

import { Placeholder } from '../placeholder'
import { DesktopSlider } from './DesktopSlider'
import { MobileSlider } from './MobileSlider'

const defaultRenderPlaceholderItem = (key: number) => <Placeholder className="h-[330px] w-[240px]" key={key} />

export type TSliderProps<TItem> = {
  title: string
  color?: TMainColor
  buttonsColor?: TMainColor
  list: TItem[] | undefined
  renderItem: (item: TItem, index: number) => ReactNode
  renderPlaceholderItem: (key: number) => ReactNode
  getItemKey: (item: TItem) => string | number
  link?: Href
  maxNbItems?: number
  emptyState?: ReactNode
  testID?: string
  containerProps?: ViewProps & { ref?: RefObject<View> }
  linkButton?: ReactNode
  autoScrollIndex?: number
  classes?: {
    base?: string
    slider?: string
    container?: string
    slot?: string
    title?: string
    titleContainer?: string
    placeholder?: string
  }
}

export const Slider = <TItem,>(props: TPickyPartial<TSliderProps<TItem>, 'renderPlaceholderItem'>): ReactNode => {
  const { lessThan } = useDimensions()

  if (lessThan.md) {
    return <MobileSlider renderPlaceholderItem={defaultRenderPlaceholderItem} {...props} />
  }

  return <DesktopSlider renderPlaceholderItem={defaultRenderPlaceholderItem} {...props} />
}
